import { render, staticRenderFns } from "./ModalAddAudioCategoryHypnosis.vue?vue&type=template&id=f4cf37d6&scoped=true&"
import script from "./ModalAddAudioCategoryHypnosis.vue?vue&type=script&lang=js&"
export * from "./ModalAddAudioCategoryHypnosis.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddAudioCategoryHypnosis.vue?vue&type=style&index=0&id=f4cf37d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cf37d6",
  null
  
)

export default component.exports